module.exports = __webpack_public_path__ + "static/img/1.2cc1a25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/1.png
// module id = 10nQ
// module chunks = 0